import { render, staticRenderFns } from "./MetaLeadsChannelDetail.vue?vue&type=template&id=5bf41c64&scoped=true"
import script from "./MetaLeadsChannelDetail.vue?vue&type=script&lang=js"
export * from "./MetaLeadsChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./MetaLeadsChannelDetail.vue?vue&type=style&index=0&id=5bf41c64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf41c64",
  null
  
)

export default component.exports